import { API_BASE_URL } from "../../config";
import { modStore } from "../Mod/modStore";
import { workshopItemToMod } from "./mappers/workshopItemToMod";
import { WorkshopItem } from "./types/workshopItem";
import { workshopStore } from "./workshopStore";

const search = async (text: string): Promise<WorkshopItem[] | null> =>
{
	if (!text?.trim())
	{
		workshopStore.clear();
		return null;
	}

	const response = await fetch(`${API_BASE_URL}/workshop/mods?text=${encodeURIComponent(text)}`, {
		method: "GET",
		headers: {
			"Authorization": sessionStorage.getItem("loginToken") || "",
			"Content-Type": "application/json"
		}
	});

	if (!response.ok)
	{
		throw new Error(`Failed to fetch mods: ${response.statusText}`);
	}

	const data = await response.json();

	if (!Array.isArray(data))
	{
		workshopStore.clear();
		return null;
	}

	workshopStore.set(data);
	return data;
};

const download = async (id: string): Promise<void> =>
{
	const workshopItem = workshopStore.get().find(item => item.publishedFileId === id);

	if (workshopItem)
	{
		modStore.add(workshopItemToMod(workshopItem));
	}

	const response = await fetch(`${API_BASE_URL}/workshop/mods/${id}/download`, {
		method: "POST",
		headers: {
			"Authorization": sessionStorage.getItem("loginToken") || "",
		}
	});

	if (!response.ok)
	{
		throw new Error(`Failed to download mod: ${response.statusText}`);
	}
};

export const workshopService = {
	search,
	download,
};
